import { observable, runInAction } from 'mobx';
import { ActivitiesOfCustomerSegment, ChartActivitiesModel, CustomerCRMModel, CustomerSegmentModel, ICustomerSegmentServices, ListCustomerCriteria, ListLazySegmentResponse } from 'services/Main/customerSegment_services';
import { DataResponse } from 'services/response';

export type CustomerSegmentStore = {
  // Danh sách customer segments
  listCustomerSegment: DataResponse<Array<CustomerSegmentModel>>
  // Danh sách customer crm
  listCustomerCRM: DataResponse<Array<CustomerCRMModel>>
  // Lấy danh sách khách hàng ngoài
  listCustomerOutside: DataResponse<Array<CustomerCRMModel>>
  // Tạo mới customer segments
  createCustomerSegment: DataResponse<null>
  // count customer criteria
  countCustomerCriteria: DataResponse<null>
  // list customer criteria
  listCustomerCriteria: DataResponse<ListCustomerCriteria[]>


  // Lấy danh sách khách hàng của customer segment theo type
  customerOfCustomerSegment: DataResponse<Array<CustomerCRMModel>>
  // danh sách hoạt động của Customer segment theo type
  activitiesOfCustomerSegment: DataResponse<Array<ActivitiesOfCustomerSegment>>
  // // chart số lượng hoạt động cho segment theo tháng
  dataChartActivities: DataResponse<Array<ChartActivitiesModel>>
  // // Chart tăng trưởng khách hàng theo Customer segment
  dataChartGrowth: DataResponse<Array<ChartActivitiesModel>>
  // Chart doanh số Customer segment
  dataChartRevenue: DataResponse<Array<ChartActivitiesModel>>
  // // lấy thông tin chi tiết segment
  detailCustomerSegment: DataResponse<CustomerSegmentModel | undefined>

  // dropdown danh sách khách hàng lazy segment
  lazySegmentList: DataResponse<Array<ListLazySegmentResponse>>
};

export interface ICustomerSegmentPresenter {
  createStore(): CustomerSegmentStore;
  //    Lấy danh sách customer segments
  getlistCustomerSegments(store: CustomerSegmentStore, data: object): Promise<void>
  // Lấy danh sách khách hàng có trên CRM
  getListCustomerCRM(store: CustomerSegmentStore, data: object): Promise<void>
  // Lấy danh sách khách hàng ngoài
  getListCustomerOutside(store: CustomerSegmentStore, data: object): Promise<void>
  // Import khách hàng ngoài CRM
  importCustomerOutside(data: object): Promise<DataResponse<null> | null>
  // Download mẫu template excel khách hàng ngoài CRM
  downloadTemplateExceCustomerOutside(): Promise<void>
  // Tạo mới customer segment
  createCustomerSegment(store: CustomerSegmentStore, data: object): Promise<boolean>
  // Cập nhật customer segmentation
  updateCustomerSegment(store: CustomerSegmentStore, data: object): Promise<boolean>

  // export customer segment
  exportReport(data: object): Promise<void>

  // count customer by criteria (Đếm khách hàng theo tiêu chí)
  countCustomerByCriteria(store: CustomerSegmentStore, data: object): Promise<void>
  // get list customer by criteria (danh sách khách hàng theo danh sách tiêu chí/ Paging)
  listCustomerByCriteria(store: CustomerSegmentStore, data: object): Promise<void>


  // Lấy danh sách khách hàng của customer segment theo type
  getCustomerOfCustomerSegment(store: CustomerSegmentStore, data: object): Promise<void>
  // danh sách hoạt động của Customer segment theo type
  getActivitiesOfCustomerSegment(store: CustomerSegmentStore, data: object): Promise<void>
  // chart số lượng hoạt động cho segment theo tháng
  getDataChartActivities(store: CustomerSegmentStore, id: string, year?: number): Promise<void>
  // Chart tăng trưởng khách hàng theo Customer segment
  getDataChartGrowthCustomerSegment(store: CustomerSegmentStore, id: string, year?: number): Promise<void>
  // Chart doanh số Customer segment
  getDataChartRevenueCustomerSegment(store: CustomerSegmentStore, id: string, year?: number): Promise<void>
  // lấy thông tin chi tiết segment
  getDetailCustomerSegment(store: CustomerSegmentStore, id: string): Promise<void>

  // Lấy dropdown danh sách khách hàng của Phân khúc khách hàng chứa tiêu chí và value đã tạo, dùng LazyCreate  phân khúc khách hàng
  getLazyCustomerSegment(store: CustomerSegmentStore, keyWord?: string): Promise<void>

  // export excel
  exportExcel(data: object): Promise<void>
}

export function createCustomerSegmentPresenter({ customerSegmentServices }: { customerSegmentServices: ICustomerSegmentServices }): ICustomerSegmentPresenter {
  return {
    createStore: (): CustomerSegmentStore =>
      observable({
        listCustomerSegment: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        listCustomerCRM: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          },
          extension: []
        },
        listCustomerOutside: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          },
          extension: []
        },
        createCustomerSegment: {
          data: null,
          message: '',
          isSuccess: false,
        },
        countCustomerCriteria: {
          data: null,
          message: '',
          isSuccess: false,
        },
        // list customer criteria
        listCustomerCriteria: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        // Lấy danh sách khách hàng của customer segment theo type
        customerOfCustomerSegment: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        // danh sách hoạt động của Customer segment theo type
        activitiesOfCustomerSegment: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        // // chart số lượng hoạt động cho segment theo tháng
        dataChartActivities: {
          data: [],
          message: '',
          isSuccess: false,
        },
        // Chart tăng trưởng khách hàng theo Customer segment
        dataChartGrowth: {
          data: [],
          message: '',
          isSuccess: false,
        },
        // Chart doanh số Customer segment
        dataChartRevenue: {
          data: [],
          message: '',
          isSuccess: false,
        },
        // lấy thông tin chi tiết segment
        detailCustomerSegment: {
          data: undefined,
          message: '',
          isSuccess: false,
        },
        // lấy thông tin chi tiết segment
        lazySegmentList: {
          data: [],
          message: '',
          isSuccess: false,
        },
      }),
    //    Lấy danh sách customer segments
    getlistCustomerSegments: async (store, dataSearch) => {
      try {
        const result = await customerSegmentServices.getlistCustomerSegments(dataSearch);
        runInAction(() => {
          store.listCustomerSegment.data = result.data;
          store.listCustomerSegment.isSuccess = result.isSuccess;
          store.listCustomerSegment.message = result.message;
          store.listCustomerSegment.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Lấy danh sách khách hàng có trên CRM
    getListCustomerCRM: async (store, dataSearch) => {
      try {
        const result = await customerSegmentServices.getListCustomerCRM(dataSearch);
        runInAction(() => {
          store.listCustomerCRM.data = result.data;
          store.listCustomerCRM.isSuccess = result.isSuccess;
          store.listCustomerCRM.message = result.message;
          store.listCustomerCRM.paging = result.paging;
          store.listCustomerCRM.extension = result.extension;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Lấy danh sách khách hàng ngoài
    getListCustomerOutside: async (store, dataSearch) => {
      try {
        const result = await customerSegmentServices.getListCustomerOutside(dataSearch);
        runInAction(() => {
          store.listCustomerOutside.data = result.data;
          store.listCustomerOutside.isSuccess = result.isSuccess;
          store.listCustomerOutside.message = result.message;
          store.listCustomerOutside.paging = result.paging;
          store.listCustomerOutside.extension = result.extension;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Import khách hàng ngoài CRM
    importCustomerOutside: async (data) => {
      try {
        const result = await customerSegmentServices.importCustomerOutside(data);
        // runInAction(() => {

        // });
        return result;
      } catch (error) {
        console.log(error);
        return null
      }
    },
    // Download mẫu template excel khách hàng ngoài CRM
    downloadTemplateExceCustomerOutside: async () => {
      try {
        await customerSegmentServices.downloadTemplateExceCustomerOutside();
        // runInAction(() => {
        // });
      } catch (error) {
        console.log(error);
      }
    },
    // Tạo mới customer segment
    createCustomerSegment: async (store, data) => {
      try {
        const result = await customerSegmentServices.createCustomerSegment(data);
        runInAction(() => {
          store.createCustomerSegment.isSuccess = result.isSuccess;
          store.createCustomerSegment.message = result.message;
        });
        return result.isSuccess;
      } catch (error) {
        console.log(error);
        return false
      }
    },
    // Cập nhật customer segment
    updateCustomerSegment: async (store, data) => {
      try {
        const result = await customerSegmentServices.updateCustomerSegment(data);
        runInAction(() => {
          store.createCustomerSegment.isSuccess = result.isSuccess;
          store.createCustomerSegment.message = result.message;
        });
        return result.isSuccess;
      } catch (error) {
        console.log(error);
        return false
      }
    },

    // export report
    exportReport: async (data) => {
      try {
        await customerSegmentServices.exportReport(data);
      } catch (error) {
        console.log(error);
      }
    },


    // count customer by criteria (Đếm khách hàng theo tiêu chí)
    countCustomerByCriteria: async (store, data) => {
      try {
        const result = await customerSegmentServices.countCustomerByCriteria(data);
        runInAction(() => {
          store.countCustomerCriteria.isSuccess = result.isSuccess;
          store.countCustomerCriteria.message = result.message;
          store.countCustomerCriteria.data = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // get list customer by criteria (danh sách khách hàng theo danh sách tiêu chí/ Paging)
    listCustomerByCriteria: async (store, data) => {
      try {
        const result = await customerSegmentServices.listCustomerByCriteria(data);
        runInAction(() => {
          store.listCustomerCriteria.isSuccess = result.isSuccess;
          store.listCustomerCriteria.message = result.message;
          store.listCustomerCriteria.data = result.data;
          store.listCustomerCriteria.paging = result.paging;

        });
      } catch (error) {
        console.log(error);
      }
    },

    // Lấy danh sách khách hàng của customer segment theo type
    getCustomerOfCustomerSegment: async (store, data) => {
      try {
        const result = await customerSegmentServices.getCustomerOfCustomerSegment(data);
        runInAction(() => {
          store.customerOfCustomerSegment.data = result.data;
          store.customerOfCustomerSegment.isSuccess = result.isSuccess;
          store.customerOfCustomerSegment.message = result.message;
          store.customerOfCustomerSegment.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // danh sách hoạt động của Customer segment theo type
    getActivitiesOfCustomerSegment: async (store, data) => {
      try {
        const result = await customerSegmentServices.getActivitiesOfCustomerSegment(data);
        runInAction(() => {
          store.activitiesOfCustomerSegment.data = result.data;
          store.activitiesOfCustomerSegment.isSuccess = result.isSuccess;
          store.activitiesOfCustomerSegment.message = result.message;
          store.activitiesOfCustomerSegment.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // chart số lượng hoạt động cho segment theo tháng
    getDataChartActivities: async (store, id, year) => {
      try {
        const result = await customerSegmentServices.getDataChartActivities(id, year);
        runInAction(() => {
          store.dataChartActivities.data = result.data;
          store.dataChartActivities.isSuccess = result.isSuccess;
          store.dataChartActivities.message = result.message;
          store.dataChartActivities.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Chart tăng trưởng khách hàng theo Customer segment
    getDataChartGrowthCustomerSegment: async (store, id, year) => {
      try {
        const result = await customerSegmentServices.getDataChartGrowthCustomerSegment(id, year);
        runInAction(() => {
          store.dataChartGrowth.data = result.data;
          store.dataChartGrowth.isSuccess = result.isSuccess;
          store.dataChartGrowth.message = result.message;
          store.dataChartGrowth.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Chart doanh số Customer segment
    getDataChartRevenueCustomerSegment: async (store, id, year) => {
      try {
        const result = await customerSegmentServices.getDataChartRevenueCustomerSegment(id, year);
        runInAction(() => {
          store.dataChartRevenue.data = result.data;
          store.dataChartRevenue.isSuccess = result.isSuccess;
          store.dataChartRevenue.message = result.message;
          store.dataChartRevenue.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // lấy thông tin chi tiết segment
    getDetailCustomerSegment: async (store, id) => {
      try {
        const result = await customerSegmentServices.getDetailCustomerSegment(id);
        runInAction(() => {
          store.detailCustomerSegment.data = result.data;
          store.detailCustomerSegment.isSuccess = result.isSuccess;
          store.detailCustomerSegment.message = result.message;
          store.detailCustomerSegment.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Lấy dropdown danh sách khách hàng của Phân khúc khách hàng chứa tiêu chí và value đã tạo, dùng LazyCreate  phân khúc khách hàng
    getLazyCustomerSegment: async (store, keyWord) => {
      try {
        const result = await customerSegmentServices.getLazyCustomerSegment(keyWord);
        runInAction(() => {
          store.lazySegmentList.data = result.data;
          store.lazySegmentList.isSuccess = result.isSuccess;
          store.lazySegmentList.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // export
    exportExcel: async (data) => {
      try {
        await customerSegmentServices.exportExcel(data);
      } catch (error) {
        console.log(error);
      }
    }

  };
}
